export default __webpack_public_path__ + "static/media/woman-with-cane-and-waving-man-illustration_white_background_x2.5e047df5.png";